module.exports = __webpack_public_path__ + "img/edit-pencil.e3a9c4a3.svg";